import { Popover as PopoverPrimitive } from 'radix-ui'
import type { ComponentPropsWithoutRef } from 'react'
import { cn } from '@/utils/cn'

export const Popover = PopoverPrimitive.Root
export const PopoverTrigger = PopoverPrimitive.Trigger
export const PopoverClose = PopoverPrimitive.Close

export function PopoverContent({
  className,
  align = 'end',
  ...props
}: ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>) {
  return (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Content
        align={align}
        sideOffset={8}
        className={cn(
          'z-50 w-80 animate-scale-in rounded-card border border-line bg-surface p-4 shadow-overlay',
          className,
        )}
        {...props}
      />
    </PopoverPrimitive.Portal>
  )
}
